import React from 'react';
import { ShieldAlertIcon } from 'lucide-react';
import { Panel } from '../../components/ui/Panel';
import { PanelHeader } from '../../components/ui/PanelHeader';
import { Button } from '../../components/ui/Button';
import { auditLog, staffMembers } from '../../data/adminPlatform';
import { formatDateTime, relativeTime } from '../../utils/format';
export function AdminStaff() {
  const withoutMfa = staffMembers.filter(member => !member.mfa);
  return <div className="space-y-5" data-id="element-724" data-mp="qflrf3opm2r1">
      <header data-id="element-725" data-mp="vgj81bu2moqf">
        <h1 className="text-xl font-semibold tracking-tight text-ink" data-id="element-726" data-mp="vfzm7k1avg74">
          Staff &amp; audit
        </h1>
        <p className="mt-1 text-sm text-ink-muted" data-id="element-727" data-mp="108kg0lk7htan">
          Who can see customer data, and what they have done with it.
        </p>
      </header>

      {withoutMfa.length > 0 && <div className="flex items-start gap-3 rounded-card border border-critical-border bg-critical-soft px-4 py-3.5" data-id="element-728" data-mp="198z2ho8wpefq">
          <ShieldAlertIcon className="mt-0.5 h-4 w-4 shrink-0 text-critical" aria-hidden="true" data-id="element-729" data-mp="1e829he8g5uqc" />
          <div data-id="element-730" data-mp="cxfyxrbt24ha">
            <p className="text-[13px] font-medium text-critical-ink" data-id="element-731" data-mp="80fqxavearnj">
              {withoutMfa.length} staff account without two-factor
            </p>
            <p className="mt-1 text-[13px] text-critical-ink/90" data-id="element-732" data-mp="3ze09ifjnnx6">
              {withoutMfa.map(m => m.name).join(', ')} can reach every
              customer&apos;s data with a password alone.
            </p>
          </div>
        </div>}

      <Panel as="section" data-id="element-733" data-mp="roosucmqqc08">
        <PanelHeader title="Staff accounts" description="Roles are the only access control here — there is no per-customer scoping." level={2} action={<Button variant="secondary" size="sm" data-id="element-735" data-mp="hzf0cvnzirbl">
              Invite staff
            </Button>} data-id="element-734" data-mp="rphreqbjpv7a" />
        <div className="overflow-x-auto" data-id="element-736" data-mp="1fesvago705pn">
          <table className="w-full min-w-[620px] border-collapse text-left" data-id="element-737" data-mp="1ffu5kixdwo6b">
            <caption className="sr-only" data-id="element-738" data-mp="1alzoln95ynax">
              Staff accounts with role, two-factor status and last activity
            </caption>
            <thead data-id="element-739" data-mp="1yicsa8ha3s5b">
              <tr className="border-b border-line bg-canvas" data-id="element-740" data-mp="1yhkxv0zf40gm">
                {['Person', 'Role', 'Two-factor', 'Last active'].map(heading => <th key={heading} scope="col" className="px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.1em] text-ink-soft" data-id="element-741" data-mp="1oskwxc1cuuzs">
                      {heading}
                    </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-line" data-id="element-742" data-mp="11ty97p8l5mdq">
              {staffMembers.map(member => <tr key={member.id} data-id="element-743" data-mp="15u8nrqag1l47">
                  <th scope="row" className="px-5 py-3 font-normal" data-id="element-744" data-mp="2w6o0dz7kkhhf">
                    <span className="block text-[13px] font-medium text-ink" data-id="element-745" data-mp="2w4a7nx0d3hd1">
                      {member.name}
                    </span>
                    <span className="block font-mono text-[11px] text-ink-soft" data-id="element-746" data-mp="ok4pekxb48q0">
                      {member.email}
                    </span>
                  </th>
                  <td className="px-5 py-3 text-[13px] text-ink-muted" data-id="element-747" data-mp="kh824gwtnofq">
                    {member.role}
                  </td>
                  <td className="px-5 py-3" data-id="element-748" data-mp="tj7l3ered2lb">
                    <span className={`rounded-full border px-2 py-0.5 text-[11px] font-medium ${member.mfa ? 'border-healthy-border bg-healthy-soft text-healthy-ink' : 'border-critical-border bg-critical-soft text-critical-ink'}`} data-id="element-749" data-mp="ti65qy3cltxs">
                      {member.mfa ? 'Enabled' : 'Missing'}
                    </span>
                  </td>
                  <td className="px-5 py-3 text-xs text-ink-soft" data-id="element-750" data-mp="3j1gasgzel5f4">
                    {relativeTime(member.lastActiveAt)}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Panel>

      <Panel as="section" data-id="element-751" data-mp="3gilewlb9p8vh">
        <PanelHeader title="Audit log" description="Anything touching money or customer access is marked sensitive and cannot be deleted." level={2} data-id="element-752" data-mp="3khavemrlr6jc" />
        <ul className="divide-y divide-line" data-id="element-753" data-mp="3ufrrfy5eebc9">
          {auditLog.map(entry => <li key={entry.id} className="flex flex-wrap items-start gap-x-4 gap-y-1.5 px-5 py-3.5" data-id="element-754" data-mp="2ws9m6xay3rd0">
              <span className={`mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full ${entry.sensitive ? 'bg-warn' : 'bg-paused'}`} aria-hidden="true" data-id="element-755" data-mp="31sdzyfkgy7zj" />
              <span className="min-w-0 flex-1" data-id="element-756" data-mp="3bigskenohjxc">
                <span className="block text-[13px] text-ink" data-id="element-757" data-mp="2e29z2fyo0mc8">
                  <span className="font-medium" data-id="element-758" data-mp="2dznsaijlmav2">{entry.actor}</span>{' '}
                  {entry.action}
                </span>
                <span className="mt-1 block font-mono text-[11px] text-ink-soft" data-id="element-759" data-mp="2bh27737xsewj">
                  {entry.target}
                </span>
              </span>
              {entry.sensitive && <span className="rounded border border-warn-border bg-warn-soft px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-[0.08em] text-warn-ink" data-id="element-760" data-mp="21iw6uq1s3gts">
                  sensitive
                </span>}
              <span className="font-mono text-[11px] text-ink-soft" data-id="element-761" data-mp="1siq1jrg8hn5p">
                {formatDateTime(entry.at)}
              </span>
            </li>)}
        </ul>
      </Panel>
    </div>;
}